module.exports = __webpack_public_path__ + "media/theme/banner__cards-c6a78844.png";